import PropTypes from 'prop-types';

import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import Colors from '../utils/colors';

import Switcher from '../Switcher/Switcher';

import MapIcon from '../MapListSwitcher/MapIcon';
import SquareListIcon from '../MapListSwitcher/SquareListIcon';

import styles from './MapListSwitcherDesktop.module.scss';

const MapListSwitcherDesktop = ({
  onClickLeft,
  onClickRight,
  isPositionRight,
  className = ''
}) => (
  <Switcher
    onClickLeft={onClickLeft}
    onClickRight={onClickRight}
    isPositionRight={isPositionRight}
    className={classNames(styles['map-list-switcher-desktop'], className)}
    renderLeftIcon={() => (
      <span className={styles['map-list-switcher-desktop__item']}>
        <SquareListIcon color={Colors.medium} />
        {trans('search.map_list_switcher.desktop.grid')}
      </span>
    )}
    renderRightIcon={() => (
      <span className={styles['map-list-switcher-desktop__item']}>
        <MapIcon color={Colors.medium} />
        {trans('search.map_list_switcher.desktop.map')}
      </span>
    )}
    dataTest="map-list-switcher"
    colorSchema="white"
  />
);

MapListSwitcherDesktop.propTypes = {
  onClickLeft: PropTypes.func.isRequired,
  onClickRight: PropTypes.func.isRequired,
  isPositionRight: PropTypes.bool.isRequired,
  className: PropTypes.string
};

export default MapListSwitcherDesktop;
